import { getType } from 'typesafe-actions'
import { cloneDeep } from 'lodash'

import * as actions from './actions'
import { StoreState, ReportAction } from './types'
import produce from 'immer'
import parseErrorMessage from 'utils/parseErrorMessage'
import { Event } from '../../types/event'

const initEvent = {
  IsLoading: false,
  MessageSuccess: undefined,
  SubmitError: undefined,
  SubmitSuccess: false,
  SubmitType: undefined,
} as Event

const initialState: StoreState = {
  dataList: {
    Total: 0,
    List: [],
  },
  event: cloneDeep(initEvent),
  activeProjectList: [],
  exportData: {
    Total: 0,
    List: [],
  },
}

export default function(
  state: StoreState = initialState,
  action: ReportAction
): StoreState {
  return produce(state, draft => {
    switch (action.type) {
      case getType(actions.exportCurrentDataAction.request):
        draft.dataList = state.dataList
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.exportData = {
          Total: 0,
          List: [],
        }
        break

      case getType(actions.getDataListAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.dataList = {
          Total: 0,
          List: [],
        }
        break

      case getType(actions.exportCurrentDataAction.success):
        draft.event.IsLoading = false
        draft.exportData = action.payload.ResponseData
        break

      case getType(actions.getDataListAction.success):
        draft.event.IsLoading = false
        draft.dataList = action.payload.ResponseData
        break

      case getType(actions.getActiveProjectListAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        draft.activeProjectList = []

        break
      case getType(actions.getActiveProjectListAction.success):
        draft.event.IsLoading = false
        draft.activeProjectList = action.payload.ResponseData.List

        break
      case getType(actions.updateDataAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        break

      case getType(actions.updateDataAction.success):
        draft.event.IsLoading = false
        draft.event.SubmitError = undefined
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'ทำรายการสำเร็จ'
        break

      case getType(actions.updateMultiProjectAction.request):
        draft.event = cloneDeep(initEvent)
        draft.event.IsLoading = true
        break

      case getType(actions.updateMultiProjectAction.success):
        draft.event.IsLoading = false
        draft.event.SubmitError = undefined
        draft.event.SubmitSuccess = true
        draft.event.MessageSuccess = 'ทำรายการสำเร็จ'
        break

      case getType(actions.updateMultiProjectAction.failure):
      case getType(actions.updateDataAction.failure):
      case getType(actions.getDataListAction.failure):
      case getType(actions.exportCurrentDataAction.failure):
      case getType(actions.getActiveProjectListAction.failure):
        draft.event.IsLoading = false
        draft.event.SubmitError = parseErrorMessage(action.payload)
        break

      case getType(actions.resetEvent):
        draft.event = cloneDeep(initEvent)
        break

      default:
        return state
    }
  })
}
